"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderDemo = void 0;
var React = __importStar(require("react"));
var logo_adminPortal_svg_1 = __importDefault(require("../../assets/images/logo-adminPortal.svg"));
var logo_orgManager_svg_1 = __importDefault(require("../../assets/images/logo-orgManager.svg"));
var logo_questionLibrary_svg_1 = __importDefault(require("../../assets/images/logo-questionLibrary.svg"));
var logo_surveyAdmin_svg_1 = __importDefault(require("../../assets/images/logo-surveyAdmin.svg"));
var logo_surveyBuilder_svg_1 = __importDefault(require("../../assets/images/logo-surveyBuilder.svg"));
var nav_grid_svg_1 = __importDefault(require("../../assets/images/nav-grid.svg"));
var nav_help_svg_1 = __importDefault(require("../../assets/images/nav-help.svg"));
var nav_home_svg_1 = __importDefault(require("../../assets/images/nav-home.svg"));
var Header_1 = require("./Header");
var HeaderDemo = /** @class */ (function (_super) {
    __extends(HeaderDemo, _super);
    function HeaderDemo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderDemo.prototype.render = function () {
        var popupMenuItems = [
            { href: '/#AdminPortal', src: logo_adminPortal_svg_1.default },
            { href: '/#OrgManager', src: logo_orgManager_svg_1.default },
            { href: '/#QuestionLibrary', src: logo_questionLibrary_svg_1.default },
            { href: '/#SurveyAdmin', src: logo_surveyAdmin_svg_1.default },
            { href: '/#SurveyBuilder', src: logo_surveyBuilder_svg_1.default },
        ];
        var linkMenuItems = [
            { href: 'https://www.google.com', text: 'Help', target: '_blank' },
            { href: '#', text: 'Contact Support', target: '_self' },
        ];
        var headerMenuItems = [
            { href: '/', src: nav_home_svg_1.default, altText: '' },
            { href: '#', src: nav_grid_svg_1.default, altText: '', popupMenuItems: popupMenuItems },
            { href: '#', src: nav_help_svg_1.default, altText: '', linkMenuItems: linkMenuItems },
        ];
        return (React.createElement("div", null,
            React.createElement("h5", null, "Default"),
            React.createElement(Header_1.Header, { menuModel: headerMenuItems, displayHeaderNavigation: true }),
            React.createElement("p", { className: 'demo' }, "Sample Header"),
            React.createElement("pre", null,
                React.createElement("code", null,
                    "const popupMenuItems = [",
                    React.createElement("br", null),
                    "\t{'href': '/#AdminPortal', 'src': {adminportalLogo}, 'text': 'Admin Portal',}",
                    React.createElement("br", null),
                    "\t{'href': '/#OrgManager', 'src': {orgmanagerLogo}, 'text': 'Org Manager',}",
                    React.createElement("br", null),
                    "\t{'href': '/#QuestionLibrary', 'src': {questionlibLogo}, 'text': 'Question Library',}",
                    React.createElement("br", null),
                    "\t{'href': '/#SurveyBuilder', 'src': {surveybuilderLogo}, 'text': 'Survey Builder',}",
                    React.createElement("br", null),
                    "];",
                    React.createElement("br", null),
                    "const linkMenuItems = [",
                    React.createElement("br", null),
                    "\t{'href': 'http://www.site1url.com', 'text': 'Site 1', 'target': '_blank' }",
                    React.createElement("br", null),
                    "\t{'href': 'http://www.site2url.com', 'text': 'Site 2', 'target': '_self' }",
                    React.createElement("br", null),
                    "];",
                    React.createElement("br", null),
                    "const headerMenuItems = [",
                    React.createElement("br", null),
                    "\t{'href': '/', 'src': navHomeImage, 'altText': ''},",
                    React.createElement("br", null),
                    "\t{'href': '#', 'src': navGridImage, 'altText': '', popupMenuItems},",
                    React.createElement("br", null),
                    "\t{'href': '#', 'src': navHelpImage, 'altText': '', linkMenuItems},",
                    React.createElement("br", null),
                    "];",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "<Header menuModel={headerMenuItems} displayHeaderNavigation={true} />",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "Notes:",
                    React.createElement("br", null),
                    "1. popupMenuItems are an array of links to be displayed when clicking on the parent icon.",
                    React.createElement("br", null),
                    "2. linkMenuItems are an array of links in standard dropdown menu format."))));
    };
    return HeaderDemo;
}(React.Component));
exports.HeaderDemo = HeaderDemo;
